import { useNavigate } from 'react-router-dom';
import { blogPosts } from './blogData';
import './Blog.css';

export default function Blog() {
  const navigate = useNavigate();

  return (
    <div className="blog-page">
      <div className="blog-hero">
        <h1>Explore Our Latest Blog Posts</h1>
        <p>Stay updated with the latest news and insights. Read our curated articles on various topics.</p>
      </div>

      <div className="container blog-grid">
        {blogPosts.map(post => (
          <div key={post.id} className="blog-card">
            <img src={post.image} alt={post.title} className="blog-card-img" />
            <div className="blog-card-body">
              <span className="blog-category">{post.category}</span>
              <h2 className="blog-card-title">{post.title}</h2>
              <p className="blog-card-excerpt">{post.excerpt}</p>
              <button className="blog-read-more" onClick={() => navigate(`/blog/${post.slug}`)}>
                Read More →
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
